import _ from 'lodash';
import './cancelDispatchServiceModal.scss';
import template from './cancelDispatchServiceModal.html';

class CancelDispatchServiceModalController {
    /* @ngInject */
    constructor() {
        this.data = this.config.data;
        this.$close = this.config.close;
        this.$dismiss = this.config.dismiss;
    }

    submit() {
        this.$close(true);
    }

    close() {
        this.$close(false);
    }
}

export default {
    template: template,
    bindings: {
        config: '<'
    },
    controller: CancelDispatchServiceModalController
};